import React from "react";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import { SurveyAnswersReview } from "../../components/surveys/SurveyAnswersReview";

export function BusinessSurveySettingsPage() {
  return (
    <SurveyAnswersReview
      render={(_isSurveyComplete, pageBody) => {
        return <StandardPageWrapper fullWidth>{pageBody}</StandardPageWrapper>;
      }}
      showAdditionalOrgSettings={true}
    />
  );
}
